import '../sass/drentsemusea.scss';
import './drentsemusea-maps';
import './fix_calendar';
import './jquery_global';
import './mixin_base';

// console.log('Assets of Drentse Musea')
